export default "__VITE_ASSET__CzRhC$Nh__"